import { Fragment, type ReactNode } from 'react';
import { t } from '../lib/i18n';
// Translate the whole sentence so each language controls word/link order.
// React escapes text and renders only explicitly supplied trusted link elements.
export function RichText({message,values={}}:{message:string;values?:Record<string,ReactNode>}) {
  return <>{t(message).split(/(\{\w+\})/g).map((part,index)=>{const name=part.match(/^\{(\w+)\}$/)?.[1];return <Fragment key={index}>{name && Object.hasOwn(values,name) ? values[name] : part}</Fragment>})}</>;
}
